import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

export function getselectHeader(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/index/gl/v1.0.0/countTj`,
        method: 'post',
        data
    })
}

export function getSiginInfo(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/index/gl/v1.0.0/signTypePie`,
        method: 'post',
        data
    })
}

export function getArtificial(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/index/gl/v1.0.0/artificialPie`,
        method: 'post',
        data
    })
}

export function getAppointmentInfo(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/index/gl/v1.0.0/signGraph`,
        method: 'post',
        data
    })
}

export function getInterventionInfo(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/index/gl/v1.0.0/artificialGraph`,
        method: 'post',
        data
    })
}